import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { CatalogService } from 'src/app/services/api/catalog/catalog.service';
import { SimpleFormItem } from 'src/app/models/catalog/catalog-form-item-types.model';
import { NotificationLevel, NotificationsService } from 'src/app/services/api/notifications/notifications.service';

export interface CancelData {
    comment: string;
}

@Component({
    selector: 'app-cancel-order',
    templateUrl: './cancel-order.component.html',
    styleUrls: ['./cancel-order.component.css'],
})
export class CancelOrderComponent implements OnInit{

    title = 'Seleccione un motivo de cancelación (Obligatorio)';
    description = 'Esta acción permite cancelar una orden.';
    placeholder = 'Debe insertar un comentario antes de continuar.';
    comments = '';
    
    form: FormGroup;
    opcionesDesplegable = []
    commentFC = new FormControl();


    constructor(private catalogService: CatalogService,
        public dialogRef: MatDialogRef<CancelOrderComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private formBuilder: FormBuilder,
        private notificationsService: NotificationsService) {
    }


    ngOnInit(): void {
      this.catalogService.getSimpleItemForm(SimpleFormItem.CANCELLATION_REASON).subscribe(data =>{
        for (const v of data) {
          this.opcionesDesplegable.push(v);
        }
        this.opcionesDesplegable.push('Otros');
      })
      this.form = this.formBuilder.group({
        reasonForm: [null, Validators.required],
        commentsForm: ['']
      });
    }

    onCommentChange() {
        this.comments = this.form.get('commentsForm').value;
    }

    cancelOrder() {
      if(this.form.get('reasonForm').value != 'Otros') {
        this.comments = this.form.get('reasonForm').value
      }
      if (this.comments == null || this.comments == ''){
        this.notificationsService.showNotification('Es obligatorio informar una razón de cancelación', NotificationLevel.ERROR);
      }else{
        let dataToReturn = {'cancel': true, 'comments': this.comments };
        this.dialogRef.close(dataToReturn);
      }
    }

}
